<script>
import { Cell, Uploader, Toast } from 'vant'

export default {
    //--------------------------------------------------
	// component name
	//--------------------------------------------------
    name: 'image-uploader',

    //--------------------------------------------------
	// component components
	//--------------------------------------------------
    components: {
        'van-cell': Cell,
        'van-uploader': Uploader,
    },

    //--------------------------------------------------
    // component props
    //--------------------------------------------------
    props: {
        label: String,
        description: String,
        placeholderUrl: String,
        placeholderImageWidth: String,
        placeholderImageHeight: String,
        imageUrl: String,
        oversizeMax: Number,
        oversizeHint: String
	},

    //--------------------------------------------------
    // component emits
    //--------------------------------------------------
	emits: ['change-data'],

    //--------------------------------------------------
    // component data
    //--------------------------------------------------
    data() {
        return {
            fileList: []
        }
    },

    //--------------------------------------------------
    // computed setter and getter
    //--------------------------------------------------
    computed: {
         placeholderImgSrc() {
             if (this.placeholderUrl) {
                 return this.placeholderUrl
             }
             else {
                 return require('../../assets/org/logo-symbol.png')
             }
         },
         placeholderImgWidth() {
             return this.placeholderImageWidth || '80px'
         },
         placeholderImgHeight() {
             return this.placeholderImageHeight || '80px'
         }
    },

    //--------------------------------------------------
    // component watch
    //--------------------------------------------------
    watch: {
        imageUrl(value) {
            console.log('watch imageUrl', value)
            if (value && this.fileList.length == 0) {
                this.fileList.push({url: value, isImage: true})
            }
        }
    },

    mounted() {
        console.log('image uploader mounted', this.imageUrl)
        if (this.imageUrl && this.fileList.length == 0) {
            this.fileList.push({url: this.imageUrl, isImage: true})
        }
    },

    //--------------------------------------------------
    // component methods
    //--------------------------------------------------
    methods: {
        //--------------------------------------------------
        // handler method
        //--------------------------------------------------
        /**
         * @handler
         * Handle the starter button click event.
         */
        onImageUploaderBtnClick() {
            console.log('onImageUploaderBtnClick')
            this.$refs.imageUploader.chooseFile()
        },
        onDeleteBtnClick() {
            console.log('onDeleteBtnClick')
            this.$emit('change-data', '')
        },
        onUploaderBtnClick() {
            console.log('onUploaderBtnClick')
        },
        onOversizeTrigger() {
            console.log('onOversizeTrigger')
            Toast(this.oversizeHint)
        },
        afterRead(file) {
            console.log('afterRead', file.file)
            this.$emit('change-data', {
                type: 'image',
                file: file.file
            })
        }
    },
}
</script>

<template>
    <!-- component -->
    <div class="image-uploader van-cell no-padding">
        <van-cell 
            class="van-cell-field"
            :title="label"
            :label="description"
            is-link
            center
            @click="onImageUploaderBtnClick"
        >
            <template #default>
                <div class="upload-container">
                    <van-uploader 
                        ref="imageUploader"
                        v-model="fileList"
                        :max-count="1"
                        :max-size="oversizeMax"
                        :after-read="afterRead"
                        @oversize="onOversizeTrigger"
                        @click-upload.stop="onUploaderBtnClick"
                        @delete="onDeleteBtnClick"
                    >
                        <template #default>
                            <img 
                                :src="placeholderImgSrc" 
                                style="margin-right: 8px;"
                                :width="placeholderImgWidth"
                                :height="placeholderImgHeight"
                            />
                        </template>
                    </van-uploader>
                </div>
            </template>
        </van-cell>
    </div>
</template>